<template>
  <section class="faq-section">
    <div class="faq-container">
      <h2 class="faq-title">
        FAQ - {{ fundName || 'Fund Name' }}
      </h2>
      <FaqAccordion @set-fund-info="handleFundInfo" />
    </div>
  </section>
</template>

<script setup>
import { ref } from 'vue'
import FaqAccordion from './FAQAccordian_prp_home.vue'

const fundName = ref('')
const categoryName = ref('')

function handleFundInfo({ fundName: name, categoryName: category }) {
  fundName.value = name
  categoryName.value = category
}
</script>

<style scoped>
.faq-section {
  width: 100%;
}

.faq-container {
  max-width: 900px;
  margin: 0 auto;
  width: 100%;
}

.faq-title {
  text-align: center;
  font-size: 42px;
  font-weight: 700;
  margin-bottom: 40px;
  color: #000;
  line-height: 52px;
  padding: 10px 10px;
  white-space: normal;
  word-wrap: break-word;
  overflow-wrap: break-word;
  max-width: 100%;
}

@media (max-width: 730px) {
  .faq-title {
    font-size: 30px;
    line-height: 38px;
    padding: 10px 18px;
  }
}

@media (max-width: 600px) {
  .faq-title {
    font-size: 26px;
    line-height: 34px;
    padding: 10px 14px;
  }
}

@media (max-width: 400px) {
  .faq-title {
    font-size: 20px;
    line-height: 28px;
    padding: 10px 8px;
  }
}
</style>
